import { getHeapGlobalEventProperties } from "../Infra/LoadHeap";
import { getAnonymousUserId } from "../Logic/AuthManager";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
const WelcomePageAnalyticsEvent = {
    WELCOME_PAGE_VIEWED: "WelcomePageViewed",
    WELCOME_PAGE_GET_STARTED_CLICKED: "WelcomePageGetStartedClicked",
};
export class PatientConsentWelcomeViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.trackWelcomePageViewed();
    }
    goToNextPage() {
        this.trackWelcomePageGetStartedClicked();
        super.goToNextPage();
    }
    trackWelcomePageViewed() {
        const { identity, user_id, properties } = this.getCommonHeapAttributes();
        if (!navigator.webdriver) {
            void this.analyticsService.trackHeapEvent({
                event: WelcomePageAnalyticsEvent.WELCOME_PAGE_VIEWED,
                identity,
                user_id,
                properties,
            });
        }
    }
    trackWelcomePageGetStartedClicked() {
        const { identity, user_id, properties } = this.getCommonHeapAttributes();
        if (!navigator.webdriver) {
            void this.analyticsService.trackHeapEvent({
                event: WelcomePageAnalyticsEvent.WELCOME_PAGE_GET_STARTED_CLICKED,
                identity,
                user_id,
                properties: { ...properties, buttonText: this.pddeGDUWelcomeConfirmButtonText },
            });
        }
    }
    getCommonHeapAttributes() {
        var _a, _b;
        const userId = (_a = getAnonymousUserId()) !== null && _a !== void 0 ? _a : undefined;
        const identity = (_b = this.authManager.id) !== null && _b !== void 0 ? _b : undefined;
        const isDataUpdate = this.patientConsentUIManager.isDataUpdate;
        const isLoggedIn = this.authManager.isLoggedIn;
        return {
            identity,
            user_id: userId,
            properties: { ...getHeapGlobalEventProperties(), isDataUpdate, isLoggedIn },
        };
    }
}
